import React from "react";
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Container,
  Typography,
  LinearProgress,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  root: {
    padding: theme.spacing(1, 0),
    // backgroundColor: theme.palette.common.white,
    position: 'relative',
    // boxShadow: `0 2px 4px 0 ${alpha(theme.palette.common.black, 0.24)}`,
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(5, 0, 2),
    },
  },
  mainTitle: {
    fontSize: theme.typography.pxToRem(20),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(24),
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(30),
    },
  },
  stepsTitle: {
    textTransform: 'uppercase',
    color: theme.palette.grey[300],
    fontSize: theme.typography.pxToRem(14),
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(20),
      margin: theme.spacing(0, 3),
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      marginTop: theme.typography.pxToRem(-5),
    },
  },
  progressBar: {
    height: 5,
    width: '100%',
    position: 'absolute',
    bottom: '0',
  },
  bar: {
    backgroundColor: theme.palette.grey[50],
  },
  children: {
    textAlign: 'right',
  },
}));


const Header = ({children, title, subTitle = '', progressIndicator = null,
}) => {
  const classes = useStyles();
  // const {
  //   children, title, subTitle, progressIndicator,
  // }: Props = props;
  return (
    <>
      <Box className={classes.root}>
        <Container>
          <Grid container alignItems="center" spacing={2}>
            <Grid item md={9} xs={8}>
              {title
              && (
              <Typography variant="h1" classes={{ root: classes.mainTitle }}>
                {title}
                {subTitle
                && (
                <Typography
                  component="span"
                  classes={{ root: classes.stepsTitle }}
                >
                  {subTitle}
                </Typography>
                )}

              </Typography>
              )}
            </Grid>
            <Grid item md={3} xs={4} className={classes.children}>
              {children}
            </Grid>
          </Grid>
        </Container>
        {progressIndicator
        && (
        <LinearProgress
          variant="determinate"
          classes={{
            root: classes.progressBar,
            colorPrimary: classes.bar,
          }}
          value={(progressIndicator.current / progressIndicator.max) * 100}
        />
        )}
      </Box>
    </>
  );
};

export default Header;
